// extracted by css-extract-rspack-plugin
export default {"tabs":"Tabs__tabs--gz8HK"};